import * as React from 'react'
import './index.scss'
import Pop from './../Pop'
import { reportFuc, regFenToYuan, getURLParam } from '../../../../utils'
import classNames from 'classnames'
interface PopInterface {
  close: any
  showAward: any
  showShare?: any
  iInvCount: number
  // balance: number
  tTotal: {
    lCash: number
    lValue: number
    lPoint: number
    lExp: number
    vGift: any
  }
}
const isHdtd = getURLParam('hdtd') !== null
const { useEffect, useMemo } = React
const PopInvite: React.FC<PopInterface> = props => {
  const { iInvCount } = props
  const { lCash, lValue, lPoint, lExp, vGift } = props.tTotal
  useEffect(() => {
    reportFuc('sys/pageview/ldx/invitationsuccess', '系统/页面展示/老带新/邀请成功浮层曝光', {})
  }, [])
  return (
    <Pop>
      <div className={classNames('pop-success-new-cover', { hdtd: isHdtd })}></div>
      <div className={classNames('pop-success-new', { hdtd: isHdtd })}>
        <div className='pop-success-title'></div>
        <i className='close' onClick={() => {
          props.close()
          reportFuc('usr/click/ldx/invitationsuccess/lookup', '用户/点击/老带新/邀请成功浮层/查看奖励点击', { button_name: 'close' })
        }} />
        <div className={classNames('pop-content', { hdtd: isHdtd })}>
          <h3>本次成功邀请{iInvCount}人</h3>
          <div className='content-gift'><span>¥</span>{regFenToYuan(lCash)}</div>
          <p className='content-money'>赚到<span>{regFenToYuan(lCash)}</span>元现金 +<span>{regFenToYuan(lValue)}</span>元礼包</p>
          <p className='pop-line'><i />价值{regFenToYuan(lValue)}元礼包<i /></p>
          {/* <div className='pop-btn'
            onClick={() => {
              reportFuc('usr/click/ldx/invitationsuccess/lookup', '用户/点击/老带新/邀请成功浮层/查看奖励点击', {})
              props.showAward()
            }}
          >查看奖励</div> */}
          <ul className='award-list'>
            {!!lPoint && <li>
              <i className={classNames('award-item', { Jf: 1 })} />
              <p className='award-count'>x{lPoint}</p>
            </li>}
            {!!lExp && <li>
              <i className={classNames('award-item', { Exp: 1 })} />
              <p className='award-count'>x{lExp}</p>
            </li>}
            {
              useMemo(() => {
                const hl = vGift.value.filter(item => parseInt(item.iItemType as string, 10) === 4);
                let count = 0
                hl.forEach(element => {
                  count += element.iItemCount
                })
                return !!count && (
                  <li>
                    <i className={classNames('award-item', { Hl: 1 })} />
                    <p className='award-count'>x{count}</p>
                  </li>
                )
              }, [])
            }
            {
              useMemo(() => {
                const yd = vGift.value.filter(item => parseInt(item.iItemType as string, 10) === 8);
                // const count = yd.length === 1 ? yd[0].iItemCount : 0;
                let count = 0
                yd.forEach(element => {
                  count += element.iItemCount
                })
                return !!count && (
                  <li>
                    <i className={classNames('award-item', { Yd: 1 })} />
                    <p className='award-count'>x{count}</p>
                  </li>
                )
              }, [])
            }
          </ul>
        </div>
        <div className='pop-btns'>
          <i className='pop-todetail' onClick={() => {
            reportFuc('usr/click/ldx/invitationsuccess/lookup', '用户/点击/老带新/邀请成功浮层/查看奖励点击', { button_name: 'look' })
            props.showAward()
          }}></i>
          <i className='pop-toshare' onClick={() => {
            reportFuc('usr/click/ldx/invitationsuccess/lookup', '用户/点击/老带新/邀请成功浮层/查看奖励点击', { button_name: 'invited' })
            props.showShare()
          }}></i>
        </div>
      </div>
    </Pop >
  )
}

export default PopInvite